import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, Button } from 'antd';
import fileDownload from 'js-file-download';
import Container from '../../components/Container';
import Spacer from '../../components/Spacer';
import PageHeader from '../../components/PageHeader';
import PickListAdvanceSearch from '../picklist/PickListAdvanceSearch';
import PortClusterList from '../picklist/DriverClusterList';
import {
  fetchDriverClusterListRequest
} from '../ducks';
import DriverClusterList from '../picklist/DriverClusterList';
function PickListCreate(props) {
  const {user} = props;
  const {
    dofetchDriverClusterListRequest
  } = props;

  const [listDetails, setListDetails] = useState({
    rows: [],
    pages: 0,
    total: 0,
  });

  const [tableFilter, setTableFilter] = useState({
    page: 0,
    pageSize: 10,
    filtered: [],
    sorted: [],
  });

  const [branchCodeList, setBranchCodeList] = useState([]);

  const [isFetchingTableDetails, setIsFetchingTableDetails] = useState(true);

  const [isExporting, setIsExporting] = useState(false);

  const [advancedFilter, setAdvancedFilter] = useState([]);
  const [reloadList, setReloadList] = useState(false);

  const breadCrumbs = [
    {
      breadcrumbName: 'Packages',
    },
    {
      breadcrumbName: 'Pick List',
    },
    {
      breadcrumbName: 'Maintenance',
    },

  ];

  function TableUpdater(state) {
    setTableFilter({
      page: state.page,
      pageSize: state.pageSize,
      filtered: state.filtered,
      sorted: state.sorted,
    });

    setIsFetchingTableDetails(true);
  }
  useEffect(()=>{
    if(reloadList){
      setIsFetchingTableDetails(true);
      dofetchDriverClusterListRequest(tableFilter, false).then((res) => {
      setListDetails({
        rows: res.payload.data.rows,
        pages: res.payload.data.page,
        total: res.payload.data.total,
      });

      setIsFetchingTableDetails(false);
    });
      setReloadList(false);
    }
  },[reloadList]);
  useEffect(() => {
    const locationTypes = ['province', 'barangay', 'city', 'cluster'];

    locationTypes.forEach((item) => {
      tableFilter.filtered = tableFilter.filtered.filter(obj => obj.id !== `advanced_${item}_filter`);
    });

    if (advancedFilter.length !== 0) {
      Object.keys(advancedFilter).forEach((item) => {
        tableFilter.filtered.push(
          {
            id: advancedFilter[item].id,
            value: advancedFilter[item].value,
          },
        );
      });
    }

    dofetchDriverClusterListRequest(tableFilter, false).then((res) => {
      setListDetails({
        rows: res.payload.data.rows,
        pages: res.payload.data.page,
        total: res.payload.data.total,
      });

      setIsFetchingTableDetails(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableFilter]);




  const exportPortClusterList = () => {
    setIsExporting(true);

    dofetchDriverClusterListRequest(tableFilter, true).then((res) => {
      const file = new Blob([res.payload.data]);
      fileDownload(file, 'Port Cluster.csv');
      setIsExporting(false);
    });
  };

  return (
    <Container
      title="Pick List Create"
    >
      <PageHeader title="PICK LIST" routes={breadCrumbs} />

      <Spacer />

      {[1,2,18].includes(user.role_id) ? <Card
        title="Driver Form"
      >
        <PickListAdvanceSearch
          tableFilter={tableFilter}
          onTableUpdate={TableUpdater}
          branchCodeList={branchCodeList}
          advancedFilter={advancedFilter}
          setAdvancedFilter={setAdvancedFilter}
          setReloadList={setReloadList}
        />
      </Card> : ''}

      <Spacer />

      <Card
        title={`Pick List - ${listDetails.total}`}
        // extra={(
        //   <React.Fragment>
        //     <Button
        //       type="primary"
        //       htmlType="submit"
        //       onClick={() => { exportPortClusterList(); }}
        //       disabled={isExporting}
        //       block
        //     >
        //         Export
        //     </Button>
        //   </React.Fragment>
        // )}
      >
        <DriverClusterList
          data={listDetails}
          tableFilter={tableFilter}
          onTableUpdate={TableUpdater}
          fetchingTableDetails={isFetchingTableDetails}
          branchCodeList={branchCodeList}
        />
      </Card>
        {/* <div style={{ display: 'none' }} id="divcontents">
          <center>
            <strong style={{ fontSize: '14px' }}>Pick List</strong>
          </center>
          <div style={{ marginBottom: '20px' }}>
            <img
              style={{ float: 'left' }}
              src="http://portal.xdelogistics.com/public/img/xde-logo.png"
              alt="xdeLogo"
            />
            <div
              style={{
                float: 'left',
                paddingTop: '15px',
                marginLeft: '20px',
                width: '570px',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>XDE Logistics</strong>
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                Ximex Building, #9B , Industrial Complex, Bagumbayan, Bicutan, 1st Ave, Taguig, 1631
                Metro Manila
              </p>
            </div>
          </div>
          <div
            style={{
              content: '',
              display: 'inline-block',
              verticalAlign: 'middle',
              width: '100%',
              marginTop: '20px',
            }}
          >
            <div
              style={{
                width: '33%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'middle',
                float: 'left',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Transmittal ID: </strong>
                {match.params.id}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Driver: </strong>
                {dispatchDetails.transmittal ? dispatchDetails.transmittal.driver : ''}
              </p>
            </div>
            <div
              style={{
                width: '33%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'middle',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Created at: </strong>
                {dispatchDetails.transmittal ? dispatchDetails.transmittal.created_at : ''}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Helper: </strong>
                {dispatchDetails.transmittal ? dispatchDetails.transmittal.helper : ''}
              </p>
            </div>
            <div
              style={{
                width: '33%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'middle',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Created by: </strong>
                {dispatchDetails.transmittal ? dispatchDetails.transmittal.created_by : ''}
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Vehicle: </strong>
                {dispatchDetails.transmittal ? dispatchDetails.transmittal.vehicle_name : ''}
              </p>
            </div>
          </div>
          <div
            style={{
              content: '',
              display: 'inline-block',
              verticalAlign: 'middle',
              width: '33%',
              marginBottom: '15px',
            }}
          >
            <p style={{ fontSize: '12px', margin: '5px' }}>
              <strong>Remarks: </strong>
              {dispatchDetails.transmittal ? dispatchDetails.transmittal.remarks : ''}
            </p>
          </div>
          <div
            style={{
              content: '',
              display: 'inline-block',
              verticalAlign: 'middle',
              width: '33%',
              marginBottom: '15px',
            }}
          >
            <p style={{ fontSize: '12px', margin: '5px' }}>
              <strong>Remittance: </strong>
              {dispatchDetails.packages
              ? dispatchDetails.packages.length !== 0
                ? dispatchDetails.packages
                  .map(res => parseFloat(res.total_price))
                  .filter(resFilter => resFilter).length === 0
                  ? 0
                  : dispatchDetails.packages
                    .map(res => parseFloat(res.total_price))
                    .filter(resFilter => resFilter)
                    .reduce((a, b) => a + b)
                    .toFixed(2)
                : 0
              : 0}
            </p>
          </div>
          <div style={{ marginBottom: '30px' }}>
            <table style={{ borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={styleTableHeader('15%')}>Request Date</th>
                  <th style={styleTableHeader('15%')}>Order #</th>
                  <th style={styleTableHeader('15%')}>Waybill #</th>
                  <th style={styleTableHeader('45%')}>{ dispatchDetails.packages ? dispatchDetails.packages[0].client_id == 1025 ? 'Collection Type' :  'Item Description' : 'Item Description'}</th>
                  <th style={styleTableHeader('10%')}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {
                  dispatchDetails.packages
                    ? dispatchDetails.packages.map((val, key) => (
                      <tr key={key}>
                        <td style={styleTableHeader('15%')}>{val.created_at}</td>
                        <td style={styleTableHeader('15%')}>{val.package_id}</td>
                        <td style={styleTableHeader('15%')}>{val.tracking_number}</td>
                        <td style={styleTableHeader('45%')}>{val.client_id == 1025 ? 'Payment Type: '+val.payment_type+" FM Collection LM Collection" : val.description}</td>
                        <td style={styleTableHeader('10%')}>{' '}</td>
                      </tr>
                    )) : null
                }
              </tbody>
            </table>
          </div>
          <p style={{ fontSize: '12px', margin: '5px' }}>
            Total Transaction:
            {' '}
            <span style={{ color: 'red' }}>{dispatchDetails.packages ? dispatchDetails.packages.length : 0}</span>
          </p>
          <div style={{ marginTop: '40px' }}>
            <strong style={{ fontSize: '12px', float: 'left' }}>
              Signature of Authorized Personnel
            </strong>
            <strong style={{ fontSize: '12px', float: 'left', marginLeft: '250px' }}>
              Signature of XDE Personnel
            </strong>
          </div>
        </div> */}
    </Container>
  );
}

PickListCreate.propTypes = {
  dofetchDriverClusterListRequest: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dofetchDriverClusterListRequest: fetchDriverClusterListRequest,
};
const mapStateToProps = state => ({
  user: state.auth.user,
});
export default connect(mapStateToProps, mapDispatchToProps)(PickListCreate);
